export default {
  apiKey: "AIzaSyBzt2Hq41m8VwM7SE9fNGuSO15muZ8Ng5w",
  authDomain: "tlinks-2222.firebaseapp.com",
  projectId: "tlinks-2222",
  storageBucket: "tlinks-2222.appspot.com",
  messagingSenderId: "116690301390",
  appId: "1:116690301390:web:137a22205a11d5a5537b9f"
}